export default __webpack_public_path__ + "static/media/report_01.904d7de8.svg";